import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getCustomReportsUsage = unaryRpc({
  name: "getCustomReportsUsage" as const,
  input: z.object({
    lookbackDays: z.number().int().min(1).max(365),
    teamId: z.string().trim().optional(),
  }),
  output: z.object({
    lookbackDays: z.number().int().min(1).max(365),
    teamId: z.string().nullable(),
    totals: z.object({
      totalReports: z.number().int().min(0),
      readyReports: z.number().int().min(0),
      failedReports: z.number().int().min(0),
      preparingReports: z.number().int().min(0),
      uniqueTeams: z.number().int().min(0),
      uniqueCreators: z.number().int().min(0),
      reportTablesReadyReports: z.number().int().min(0),
      rawTablesReadyReports: z.number().int().min(0),
      successRate: z.number().min(0).max(1).nullable(),
    }),
    daily: z.array(
      z.object({
        date: z.string(),
        totalReports: z.number().int().min(0),
        readyReports: z.number().int().min(0),
        failedReports: z.number().int().min(0),
        preparingReports: z.number().int().min(0),
      }),
    ),
    failureCodes: z.array(
      z.object({ code: z.string(), count: z.number().int().min(0) }),
    ),
    recentFailures: z.array(
      z.object({
        rowId: z.string(),
        publicId: z.string(),
        teamId: z.string(),
        title: z.string().nullable(),
        requestedQuestion: z.string(),
        errorMessage: z.string().nullable(),
        createdAt: z.date(),
        updatedAt: z.date(),
      }),
    ),
  }),
});

export type GetCustomReportsUsageInput = z.infer<
  typeof getCustomReportsUsage.input
>;
export type GetCustomReportsUsageOutput = z.infer<
  typeof getCustomReportsUsage.output
>;
